import * as React from 'react'

import { Fields } from 'embed/constants/fields'

export const useCreateAccount = (
  dispatchCreateAccount: (password: string) => Promise<string | undefined>,
  onSuccess?: () => void,
) => {
  // State
  const [password, setPassword] = React.useState<string | undefined>()
  const [error, setError] = React.useState<string | undefined>()
  const [isLoading, setIsLoading] = React.useState(false)
  const [shouldShowValidationStatus, setShouldShowValidationStatus] = React.useState(false)
  const isValid = password !== undefined ? password.length > 0 && Fields.Password.validate(password, undefined) : false

  // Handlers
  const onContinue = async () => {
    if (!isValid) {
      return
    }

    setIsLoading(true)

    const errorMessage = password !== undefined ? await dispatchCreateAccount(password) : undefined
    if (errorMessage !== undefined) {
      setError(errorMessage)
    } else {
      onSuccess?.()
    }

    setIsLoading(false)
  }
  const onChange = (value: string) => setPassword(value)
  const onBlur = () => setShouldShowValidationStatus(true)
  const onKeyDown = async (key: string) => {
    if (key === 'Enter') {
      await onContinue()
    }
  }

  return {
    error,
    isLoading,
    isValid,
    onBlur,
    onChange,
    onContinue,
    onKeyDown,
    password,
    shouldShowValidationStatus,
  }
}
